import React, { useState } from "react";
import { FaGithub, FaLinkedin, FaDownload, FaChevronDown, FaBars } from "react-icons/fa";
import { useLanguage, useLocalizedStrings } from "../Localization";

const TopBar = () => {
  const setLanguage = useLanguage(); // Dil değiştirme fonksiyonunu al
  const strings = useLocalizedStrings(); // Dil dosyasından çevirileri al

  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isMenuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="flex justify-between items-center px-8 py-2 bg-[#FBF3B9] shadow-md relative border-4 border-black rounded-md">
      {/* Dil Seçeneği (Solda) */}
      <div className="relative flex items-center">
        <button
          onClick={() => setDropdownOpen(!isDropdownOpen)}
          className="flex items-center space-x-2 cursor-pointer px-4 py-2 rounded-md transition-all duration-300 border-2 border-transparent hover:border-black hover:bg-[#B7B1F2] hover:text-white"
        >
          <span>{strings.language}</span>
          <FaChevronDown className="text-sm" />
        </button>

        {isDropdownOpen && (
          <div className="absolute left-0 mt-[120px] z-40 w-32 bg-white border border-black rounded-md shadow-lg">
            <div
              className="flex items-center px-4 py-2 hover:bg-gray-200 cursor-pointer rounded-md"
              onClick={() => {
                setLanguage("en");
                setDropdownOpen(false); // Dil değiştirildikten sonra dropdown'ı kapat
              }}
            >
              <img src="https://flagcdn.com/w40/gb.png" alt="English" className="w-6 h-5 mr-2" />
              English
            </div>
            <div
              className="flex items-center px-4 py-2 hover:bg-gray-200 cursor-pointer rounded-md"
              onClick={() => {
                setLanguage("tr");
                setDropdownOpen(false); // Dil değiştirildikten sonra dropdown'ı kapat
              }}
            >
              <img src="https://flagcdn.com/w40/tr.png" alt="Türkçe" className="w-6 h-5 mr-2" />
              Türkçe
            </div>
          </div>
        )}
      </div>

      {/* Menü (Orta) */}
      <ul className="hidden lg:flex space-x-6 text-lg font-semibold">
        {[{ name: strings.home, id: "home" },
          { name: strings.about, id: "about" },
          { name: strings.skills, id: "skills" },
          { name: strings.projects, id: "projects" },
          { name: strings.contact, id: "contact" }
        ].map((item) => (
          <li key={item.name}>
            <a
              href={item.id === "home" ? "/" : `#${item.id}`} 
              className="cursor-pointer px-4 py-2 rounded-md transition-all duration-300 border-2 border-transparent hover:border-black hover:bg-[#B7B1F2] hover:text-white"
            >
              {item.name}
            </a>
          </li>
        ))}
      </ul>

      {/* Sosyal Medya İkonları (Sağda) */}
      <div className="hidden md:flex space-x-4 text-2xl">
        <a 
          href="https://github.com/oyelmali" 
          target="_blank" 
          rel="noopener noreferrer"
          className="cursor-pointer transition-all duration-300 p-2 rounded-full border-2 border-transparent hover:bg-[#B7B1F2] hover:shadow-md hover:scale-110 hover:border-black"
        >
          <FaGithub />
        </a>

        <a 
          href="https://linkedin.com/in/oyelmali" 
          target="_blank" 
          rel="noopener noreferrer"
          className="cursor-pointer transition-all duration-300 p-2 rounded-full border-2 border-transparent hover:bg-[#B7B1F2] hover:shadow-md hover:scale-110 hover:border-black"
        >
          <FaLinkedin />
        </a>

        <a 
          href={setLanguage === 'tr' ? "https://drive.usercontent.google.com/download?id=1vMx-UUeHy9J8gqsjeT5pD7hAZM1ks_-L&export=download&authuser=0&confirm=t&uuid=003c6758-e40e-4e9c-aa01-b737172d81c7&at=AEz70l6_HY_J1XidL9l8T_Acwk-D:1741608926048" : "https://drive.usercontent.google.com/download?id=1sGPJhv1mXUgcch8t9xcrD5TvheR2GH8E&export=download&authuser=0&confirm=t&uuid=44414688-4a82-45b9-ab89-8a1856a99c81&at=AEz70l4KZzrccwaCMaQk7Hdqy_h7:1741644460732" }
          download
          className="cursor-pointer transition-all duration-300 p-2 rounded-full border-2 border-transparent hover:bg-[#B7B1F2] hover:shadow-md hover:scale-110 hover:border-black"
        >
          <FaDownload />
        </a>
      </div>

      {/* Hamburger Menü (Mobil) */}
      <button 
        onClick={() => setMenuOpen(!isMenuOpen)} 
        className="lg:hidden p-2"
      >
        <FaBars className="text-2xl" />
      </button>

      {/* Menü (Mobil) */}
      <div className={`fixed z-30 top-0 right-0 w-64 h-full bg-[#FBF3B9] shadow-lg transition-all duration-300 ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'} lg:hidden`}>
        <div className="flex justify-between items-center p-4">
          <button
            onClick={() => setMenuOpen(false)}
            className="text-2xl cursor-pointer"
          >
            X
          </button>
        </div>
        <ul className="space-y-6 text-lg font-semibold p-4">
          {[{ name: strings.home, id: "home" },
            { name: strings.about, id: "about" },
            { name: strings.skills, id: "skills" },
            { name: strings.projects, id: "projects" },
            { name: strings.contact, id: "contact" }
          ].map((item) => (
            <li key={item.name}>
              <a
                href={item.id === "home" ? "/" : `#${item.id}`} 
                className="cursor-pointer px-4 py-2 rounded-md transition-all duration-300 border-2 border-transparent hover:border-black hover:bg-[#B7B1F2] hover:text-white"
              >
                {item.name}
              </a>
            </li>
          ))}
        </ul>
        <div className="flex justify-center space-x-4 text-2xl p-4">
          <a 
            href="https://github.com/oyelmali" 
            target="_blank" 
            rel="noopener noreferrer"
            className="cursor-pointer transition-all duration-300 p-2 rounded-full border-2 border-transparent hover:bg-[#B7B1F2] hover:shadow-md hover:scale-110 hover:border-black"
          >
            <FaGithub />
          </a>

          <a 
            href="https://linkedin.com/in/oyelmali" 
            target="_blank" 
            rel="noopener noreferrer"
            className="cursor-pointer transition-all duration-300 p-2 rounded-full border-2 border-transparent hover:bg-[#B7B1F2] hover:shadow-md hover:scale-110 hover:border-black"
          >
            <FaLinkedin />
          </a>

          <a 
            href={setLanguage === 'tr' ? "https://drive.usercontent.google.com/download?id=1vMx-UUeHy9J8gqsjeT5pD7hAZM1ks_-L&export=download&authuser=0&confirm=t&uuid=003c6758-e40e-4e9c-aa01-b737172d81c7&at=AEz70l6_HY_J1XidL9l8T_Acwk-D:1741608926048" : "https://drive.usercontent.google.com/download?id=1sGPJhv1mXUgcch8t9xcrD5TvheR2GH8E&export=download&authuser=0&confirm=t&uuid=44414688-4a82-45b9-ab89-8a1856a99c81&at=AEz70l4KZzrccwaCMaQk7Hdqy_h7:1741644460732" }
            download
            className="cursor-pointer transition-all duration-300 p-2 rounded-full border-2 border-transparent hover:bg-[#B7B1F2] hover:shadow-md hover:scale-110 hover:border-black"
          >
            <FaDownload />
          </a>
        </div>
      </div>
    </nav>
  );
};

export default TopBar;
